import Footer from './Footer/Footer';
import { AccessibilityNavigation } from './Header/AccessibilityNavigation/AccessibilityNavigation';
import { Header } from './Header/Header';
import Webline from './Webline/Webline';
import useTranslation from 'next-translate/useTranslation';

const ErrorLayout: FC = ({ children }) => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col justify-between">
            <AccessibilityNavigation />
            <Webline type="colored" style={{ marginBottom: '32px', position: 'relative' }}>
                <Header simple />
            </Webline>
            <main aria-label={t('Error page content')} id="main-content">
                {children}
            </main>
            <Webline type="light">
                <Footer simple />
            </Webline>
        </div>
    );
};

/* @component */
export default ErrorLayout;
